
import { XMarkIcon } from '@heroicons/react/24/outline'
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import "../../../../shared/components/header.css";
import { NotificationEventMessage } from '@models/api';
import { format } from 'date-fns';

interface SidebarLayoutProps {
    notifications: NotificationEventMessage[],
    sidebarOpen: boolean,
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>,
    setPopupOpen?: React.Dispatch<React.SetStateAction<boolean>>,
    customerImageUrl?: string | null,
    customerName?: string | null,

}

const NotificationsSidebar: React.FC<SidebarLayoutProps> = ({ notifications, sidebarOpen, setSidebarOpen, customerImageUrl, customerName }: SidebarLayoutProps) => {

    return (
        <div>

            <Transition show={sidebarOpen}>
                <Dialog className="relative z-10" onClose={setSidebarOpen}>
                    <TransitionChild
                        enter="ease-in-out duration-500"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in-out duration-500"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />
                    </TransitionChild>

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                                <TransitionChild
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"
                                >
                                    <DialogPanel className="pointer-events-auto w-full">
                                        <div className="flex h-full w-[308px] flex-col overflow-y-scroll bg-white px-6 py-6 shadow-xl rounded-l-xl gap-y-6">
                                            <div className="flex items-end justify-end">
                                                <button
                                                    type="button"
                                                    className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                                    onClick={() => setSidebarOpen(false)}
                                                >
                                                    <span className="absolute -inset-2.5" />
                                                    <span className="sr-only">Close panel</span>
                                                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                                                </button>
                                            </div>

                                            <div className="relative flex flex-col gap-y-6 items-start self-center">
                                                <div className='flex gap-x-[10px] px-4 pt-[10px] items-center self-center'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="24" viewBox="0 0 21 24" fill="none">
                                                        <path d="M14.8746 22.4997C14.8746 22.7318 14.7824 22.9543 14.6184 23.1184C14.4543 23.2825 14.2317 23.3747 13.9996 23.3747H6.99974C6.76768 23.3747 6.54512 23.2825 6.38103 23.1184C6.21694 22.9543 6.12475 22.7318 6.12475 22.4997C6.12475 22.2676 6.21694 22.0451 6.38103 21.881C6.54512 21.7169 6.76768 21.6247 6.99974 21.6247H13.9996C14.2317 21.6247 14.4543 21.7169 14.6184 21.881C14.7824 22.0451 14.8746 22.2676 14.8746 22.4997ZM20.7644 18.9997C20.6126 19.2672 20.3922 19.4893 20.1259 19.6431C19.8596 19.7969 19.5571 19.8769 19.2496 19.8747H1.74981C1.44218 19.8743 1.1401 19.7928 0.874011 19.6384C0.60792 19.4841 0.387224 19.2623 0.234168 18.9954C0.0811122 18.7286 0.00110425 18.4261 0.00220854 18.1185C0.00331284 17.8109 0.0854904 17.509 0.240458 17.2432C0.847481 16.1976 1.74981 13.2401 1.74981 9.37488C1.74981 7.05427 2.67167 4.8287 4.31259 3.18778C5.95351 1.54686 8.17908 0.625 10.4997 0.625C12.8203 0.625 15.0459 1.54686 16.6868 3.18778C18.3277 4.8287 19.2496 7.05427 19.2496 9.37488C19.2496 13.239 20.153 16.1976 20.76 17.2432C20.9165 17.5093 20.9993 17.8123 20.9999 18.121C21.0005 18.4298 20.9188 18.7331 20.7633 18.9997H20.7644ZM19.2496 18.1248C18.4041 16.6734 17.4996 13.3178 17.4996 9.37488C17.4996 7.51839 16.7621 5.73794 15.4494 4.4252C14.1366 3.11246 12.3562 2.37498 10.4997 2.37498C8.6432 2.37498 6.86275 3.11246 5.55001 4.4252C4.23728 5.73794 3.49979 7.51839 3.49979 9.37488C3.49979 13.3189 2.59418 16.6745 1.74981 18.1248H19.2496Z" fill="black" />
                                                    </svg>
                                                    <p className='text-[#667085] text-base font-semibold'> All Notifications </p>
                                                </div>
                                            </div>

                                            {
                                                notifications.length !== 0 ?
                                                    <div className='flex flex-col items-center self-center gap-y-2'>
                                                        {
                                                            notifications.map((item, index) => (
                                                                <div key={index}>
                                                                    <div className='m-notification-div'>
                                                                        <div className="w-[40px] h-[40px] bg-[#004E98] rounded-3xl flex items-center justify-center ">
                                                                            {
                                                                                customerImageUrl ?
                                                                                    <img src={customerImageUrl} alt="profile_img" className="w-[40px] h-[40px] rounded-3xl" />
                                                                                    :
                                                                                    <p className="text-white text-lg font-semibold cursor-pointer"> {customerName ? customerName[0].toUpperCase() : "U"} </p>
                                                                            }
                                                                        </div>

                                                                        <div className='m-content-div'>
                                                                            <p className='m-title'> {item.title} </p>
                                                                            {
                                                                                item.description && item.description.length !== 0 ?
                                                                                    <div className='m-mid-div'>
                                                                                        <div className='m-left-div' />
                                                                                        <p className='m-right-div'> {item.description} </p>
                                                                                    </div>
                                                                                    : ""
                                                                            }
                                                                            <p className='m-date'> {format(item.createdAt / 1_000_000, 'MMM d, yyyy')} </p>
                                                                        </div>
                                                                    </div>

                                                                    <div className='h-[1px] self-stretch bg-[#E4E8EE]' />
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                    :
                                                    <div className='flex flex-col py-[40px] px-[16px] gap-y-2 items-center self-stretch'>
                                                        <p className="text-[#1A1F36] text-center text-base font-medium self-stretch"> No Notification Yet </p>
                                                        <p className="text-[#1A1F36] text-center text-sm font-normal"> You have no notifications right now. <br /> Come back later. </p>
                                                        <button className="header-start-assessment text-nowrap"> Refresh </button>
                                                    </div>
                                            }
                                        </div>
                                    </DialogPanel>
                                </TransitionChild>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </div>
    )
}

export default NotificationsSidebar;
